<template>
  <div
    class="message-box"
    :class="{ 'urgent-type': message.type === MESSAGE_TYPE_URGENT, 'message-box--readed': message.read }"
    :style="{ cursor: message.link ? 'pointer' : 'normal' }"
  >
    <a
      v-if="message.link"
      class="message-box__content-area__link"
    >
      <div>
        <p class="message-box__content-area__title">{{ message.title }}</p>
        <p class="message-box__content-area__content">{{ message.message }}</p>
      </div>
      <md-tooltip>Abrir Notificação</md-tooltip>
    </a>

    <div
      v-else
      class="message-box__content-area"
    >
      <p class="message-box__content-area__title">
        {{ message.title }}
      </p>
      <p class="message-box__content-area__content">
        {{ message.message }}
      </p>
    </div>

    <div
      v-if="!message.read && message.type !== MESSAGE_TYPE_URGENT"
      class="message-box__buttons-area"
      @click="markAsRead()"
    >
      <md-icon
        id="helpIcon"
        class="check-to-read-icon"
      >
        check
      </md-icon>
    </div>

    <div
      v-else-if="message.read"
      class="message-box__readed-date"
    >
      <md-icon
        id="helpIcon"
        class="check-to-read-icon"
      >
        check
      </md-icon> Lido: {{ convertDate(message['read-date']) }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MESSAGE_TYPE_URGENT } from '@/enums'
import Moment from 'moment'

export default {
  name: 'MessageBox',
  props: {
    message: Object
  },
  data: () => {
    return {
      MESSAGE_TYPE_URGENT: MESSAGE_TYPE_URGENT
    }
  },
  methods: {
    markAsRead() {
      this.$emit('read-message')
    },
    convertDate(date) {
      return Moment.utc(date).format('DD/MM/YYYY HH:mm')
    }
  },
  computed: {
    ...mapGetters(['isComunicationSidebarVisible'])
  }
}
</script>

<style lang="scss">
@import '../../../../static/stylesheets/variables';

.message-box {
  padding: 40px 10px 40px 40px;
  color: #a7a7a7;
  line-height: 1.17;
  letter-spacing: 0.5px;
  border-bottom-style: solid;
  border-bottom-color: #f4f4f4;
  width: 90%;
  display: flex;
  border-left: 1px solid #e2e2e2;
  border-top: 1px solid #e2e2e2;
  background-color: #ffffff;

  &--readed {
    filter: grayscale(0.9);
    flex-direction: column;
  }

  &:last-child {
    border-bottom: 1px solid #e2e2e2;
  }

  &__content-area {
    width: 85%;

    &:hover {
      color: #a7a7a7;
      cursor: default;
    }

    &__title {
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 15px;
      text-transform: uppercase;
      overflow-wrap: break-word;
      -ms-word-wrap: break-word;
    }

    &__link {
      width: 85%;
      color: #a7a7a7 !important;

      &:hover {
        color: #8e3668 !important;
        text-decoration: none !important;
      }
    }

    &__content {
      font-size: 12px;
      font-weight: 500;
      overflow-wrap: break-word;
      -ms-word-wrap: break-word;
    }
  }

  &__buttons-area {
    width: 15%;
  }

  .check-to-read-icon {
    color: #65c89a;
    font-size: 1.8em;
    cursor: pointer;
  }

  &__readed-date {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 40px;
    margin-top: 24px;
    margin-bottom: -18px;
    font-weight: 600;
    font-size: 12px;

    .md-icon {
      margin: 0;
      margin-right: 8px;
    }
  }
}

.urgent-type {
  background-image: url('/static/images/icon-pin.svg');
  background-position-x: 90%;
  background-position-y: 0;
  background-size: 22px;
  background-repeat: no-repeat;
  border-top: none;
}
</style>
